import { Typography, Box } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function PoliticaCookies(){
  return (
    <>
      <SEO 
        title="Política de Cookies | Rolsys Solutions"
        description="Política de cookies de Rolsys Solutions. Información sobre el uso de cookies en nuestro sitio web."
      />

      <Box>
        <Typography variant="h3" sx={{ mb:3, fontWeight:800 }}>
          Política de Cookies
        </Typography>

        <Typography paragraph>
          Este sitio web utiliza cookies para mejorar la experiencia de navegación y analizar 
          el uso del sitio. Las cookies son pequeños archivos de texto que se almacenan en su 
          dispositivo cuando visita nuestro sitio web.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Tipos de cookies que utilizamos
        </Typography>
        <Typography paragraph>
          <strong>Cookies técnicas:</strong> Necesarias para el funcionamiento básico del sitio web.
        </Typography>
        <Typography paragraph>
          <strong>Cookies analíticas:</strong> Nos ayudan a entender cómo los visitantes interactúan 
          con el sitio web, recopilando información de forma anónima.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Gestión de cookies
        </Typography>
        <Typography paragraph>
          Puede gestionar sus preferencias de cookies desde la configuración de su navegador web. 
          La desactivación de cookies puede afectar la funcionalidad del sitio.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Cookies de terceros
        </Typography>
        <Typography paragraph>
          Este sitio puede utilizar servicios de terceros como Google Analytics para análisis 
          de tráfico web, los cuales pueden establecer sus propias cookies.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
          Última actualización: Enero 2024
        </Typography>
      </Box>
    </>
  );
}